import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { CorrispondenzaPartenzaDTO } from "@app/shared/dto/gescor/corrispondenza-partenzaDTO";
import { CorrispondenzaPartenzaVO } from "@app/shared/vo/gescor/corrispondenza-partenzaVO";
import { MapperUtente } from "../mapper-utente";
import { MapperSettore } from "../mapper-settore";
import { MapperClassificaGescor } from "./mapper-classifica-gescor";
import { MapperMetadatiProtocollo } from "../mapper-metadati-protocollo";
import { DocumentoGescorDTO } from "@app/shared/dto/gescor/documeto-gescorDTO";
import { MapperDocumentoGescor } from "./mapper-documento-gescor";
import { DocumentoGescorVO } from "@app/shared/vo/gescor/documento-gescorVO";
import { MapperDestinatarioInterno } from "./mapper-destinatario-interno";
import { MapperDestinatario } from "./mapper-destinatario";
import { MapperDestinatarioDipendente } from "./mapper-destinatario-dipendente";
import { MetadatiProtocolloGescorVO } from "@app/shared/vo/gescor/metadati-protocollo-gescorVO";

@Injectable({
  providedIn: "root",
})
export class MapperCorrispondenzaPartenza
  implements
    MapperInterface<CorrispondenzaPartenzaDTO, CorrispondenzaPartenzaVO> {
  constructor(
    private mapperClassifica: MapperClassificaGescor,
    private mapperDocumentoGescor: MapperDocumentoGescor,
    private mapperMetadatiProtocollo: MapperMetadatiProtocollo,
    /*     private mapperDipendente: MapperDipendente, */
    private mapperUtente: MapperUtente,
    private mapperSettore: MapperSettore,
    /*     private mapperVisibilitaPartenza: MapperVisibilitaPartenza,*/
    private mapperDestinatariInterni: MapperDestinatarioInterno,
    private mapperDestinatari: MapperDestinatario,
    private mapperDestinatarioDipendente: MapperDestinatarioDipendente
  ) {}

  convertVoToDto(e: CorrispondenzaPartenzaVO): CorrispondenzaPartenzaDTO {
    // console.log("[MapperCorrispondenzaPartenza] convertVoToDto ", e);
    const corrispondenzaPartenzaDTO = new CorrispondenzaPartenzaDTO();
    corrispondenzaPartenzaDTO.oggetto = e.oggetto;
    corrispondenzaPartenzaDTO.primario = this.mapperDocumentoGescor.convertVoToDto(
      e.primario
    );
    corrispondenzaPartenzaDTO.allegati = new Array<DocumentoGescorDTO>();
    e.allegati.forEach((allegato) => {
      corrispondenzaPartenzaDTO.allegati.push(
        this.mapperDocumentoGescor.convertVoToDto(allegato)
      );
    });
    corrispondenzaPartenzaDTO.dataInserimento = e.dataInserimento; //      corrispondenzaPartenzaDTO.firmatario = this.mapperUtente.convertVoToDto(e.f)

    /*   corrispondenzaPartenzaDTO.classifica = this.mapperClassifica.convertListVoToDto(
      e.classifica
    ); 
    corrispondenzaPartenzaDTO.descrizioneAllegati = e.descrizioneAllegati;
    corrispondenzaPartenzaDTO.numeroAllegati = e.numeroAllegati;
  /*   corrispondenzaPartenzaDTO.destinatariInterni = this.mapperDestinatariInterni.convertListVoToDto(
      e.destinatariInterni
    );
    corrispondenzaPartenzaDTO.destinatari = this.mapperDestinatari.convertListVoToDto(
      e.destinatari
    );
    if (e.destinatariDipendenti !== null && e.destinatariDipendenti !== undefined) {

      corrispondenzaPartenzaDTO.destinatariDipendenti = this.mapperDestinatarioDipendente.convertListVoToDto(
        e.destinatariDipendenti
      );
    }
   */ corrispondenzaPartenzaDTO.mittente = this.mapperSettore.convertVoToDto(
      e.mittente
    );
    //   corrispondenzaPartenzaDTO.stato = e.stato;
    //  corrispondenzaPartenzaDTO.riservata = e.riservato;
    /*     corrispondenzaPartenzaDTO.visibilitaPartenza = this.mapperUtente.convertListVoToDto(
      e.visibilitaUtenti
    ); */
    /*  corrispondenzaPartenzaDTO.tipoProtocolloEnum = e.tipoProtocollo;
    if (e.metadatiProtocollo !== null) {
      corrispondenzaPartenzaDTO.metadatiProtocollo = this.mapperMetadatiProtocollo.convertVoToDto(
        e.metadatiProtocollo
      );
    }
    if (e.datiFirmaPartenza !== undefined) {
      corrispondenzaPartenzaDTO.datiFirma = this.mapperDatiFirmaPartenza.convertVoToDto(
        e.datiFirmaPartenza
      );
    }
 */
    return corrispondenzaPartenzaDTO || new CorrispondenzaPartenzaDTO();
  }

  convertDtoToVo(e: CorrispondenzaPartenzaDTO): CorrispondenzaPartenzaVO {
    // console.log("[MapperCorrispondenzaPartenza.convertDtoToVo] dto:", e);
    const corrispondenzaPartenzaVO = new CorrispondenzaPartenzaVO();
    corrispondenzaPartenzaVO.oggetto = e.oggetto;
    corrispondenzaPartenzaVO.id = e.id;
    corrispondenzaPartenzaVO.dataInserimento = e.dataInserimento;
    corrispondenzaPartenzaVO.firmatario = this.mapperUtente.convertDtoToVo(
      e.firmatario
    );
    corrispondenzaPartenzaVO.primario = this.mapperDocumentoGescor.convertDtoToVo(
      e.primario
    );
    corrispondenzaPartenzaVO.allegati = new Array<DocumentoGescorVO>();
    e.allegati.forEach((allegato) => {
      corrispondenzaPartenzaVO.allegati.push(
        this.mapperDocumentoGescor.convertDtoToVo(allegato)
      );
    });

    /*   corrispondenzaPartenzaVO.documenti = new Array<DocumentoVO>();
    if (e.primario !== null) {
      let primario = new DocumentoVO();
      primario = this.mapperDocumenti.convertDtoToVo(e.primario);
      primario.primario = true;
      corrispondenzaPartenzaVO.documenti.push(primario);
    }
    if (e.allegati !== null && e.allegati.length > 0) {
      e.allegati.forEach(allegato => {
        corrispondenzaPartenzaVO.documenti.push(
          this.mapperDocumenti.convertDtoToVo(allegato)
        );
      });
    }
    if (e.richiesteAssociate) {
      corrispondenzaPartenzaVO.richiesteAssociate = true;
      corrispondenzaPartenzaVO.tipoRichieste = e.tipoRichieste;
    }*/
    corrispondenzaPartenzaVO.classifica = this.mapperClassifica.convertListDtoToVo(
      e.classifica
    );
    corrispondenzaPartenzaVO.classificaInterna = this.mapperClassifica.convertListDtoToVo(
      e.classificaInterna
    );
    if (e.metadatiProtocollo != null) {
      corrispondenzaPartenzaVO.metadatiProtocollo = new MetadatiProtocolloGescorVO();
      corrispondenzaPartenzaVO.metadatiProtocollo.numero = e.metadatiProtocollo.numeroProtocollo;
      corrispondenzaPartenzaVO.metadatiProtocollo.data = e.metadatiProtocollo.dataProtocollo;
    }
    corrispondenzaPartenzaVO.descrizioneAllegati = e.descrizioneAllegati;
    corrispondenzaPartenzaVO.numeroAllegati = e.numeroAllegati;
    corrispondenzaPartenzaVO.destinatariInterni = this.mapperDestinatariInterni.convertListDtoToVo(
      e.destinatariInterni
    );
    corrispondenzaPartenzaVO.destinatari = this.mapperDestinatari.convertListDtoToVo(
      e.destinatari
    );

    if (
      e.destinatariDipendenti !== null &&
      e.destinatariDipendenti !== undefined
    ) {
      corrispondenzaPartenzaVO.destinatariDipendenti = this.mapperDestinatarioDipendente.convertListDtoToVo(
        e.destinatariDipendenti
      );
    }
    corrispondenzaPartenzaVO.destinatariCartacei = this.mapperDestinatari.convertListDtoToVo(
      e.destinatariCartacei
    );
    if (
      corrispondenzaPartenzaVO.destinatari !== undefined &&
      corrispondenzaPartenzaVO.destinatari.length > 0
    ) {
      corrispondenzaPartenzaVO.destinatari.forEach((destinatario) => {
        if (corrispondenzaPartenzaVO.destinatariString !== "") {
          corrispondenzaPartenzaVO.destinatariString =
            `${corrispondenzaPartenzaVO.destinatariString}, `;
        }
        corrispondenzaPartenzaVO.destinatariString =
          corrispondenzaPartenzaVO.destinatariString +
          destinatario.recapitoVO.denominazioneSoggetto;
      });
    }
    if (
      corrispondenzaPartenzaVO.destinatariCartacei !== undefined &&
      corrispondenzaPartenzaVO.destinatariCartacei.length > 0
    ) {
      corrispondenzaPartenzaVO.destinatariCartacei.forEach((destinatario) => {
        if (corrispondenzaPartenzaVO.destinatariString !== "") {
          corrispondenzaPartenzaVO.destinatariString =
            `${corrispondenzaPartenzaVO.destinatariString}, `;
        }
        corrispondenzaPartenzaVO.destinatariString =
          corrispondenzaPartenzaVO.destinatariString +
          destinatario.recapitoVO.denominazioneSoggetto;
      });
    }
    if (
      corrispondenzaPartenzaVO.destinatariDipendenti !== undefined &&
      corrispondenzaPartenzaVO.destinatariDipendenti.length > 0
    ) {
      corrispondenzaPartenzaVO.destinatariDipendenti.forEach((destinatario) => {
        if (corrispondenzaPartenzaVO.destinatariString !== "") {
          corrispondenzaPartenzaVO.destinatariString =
            `${corrispondenzaPartenzaVO.destinatariString}, `;
        }
        corrispondenzaPartenzaVO.destinatariString =
          `${corrispondenzaPartenzaVO.destinatariString}${destinatario.dipendente.cognome} ${destinatario.dipendente.nome}`;
      });
    }

    /*     if (
      (e.tipoProtocolloEnum === TipoProtocolloEnum.INTERNO_CARTACEO ||
        e.tipoProtocolloEnum === TipoProtocolloEnum.INTERNO_DIGITALE) &&
      (corrispondenzaPartenzaVO.destinatariInterni != null && corrispondenzaPartenzaVO.destinatariInterni.length > 0)
    ) {
       if (corrispondenzaPartenzaVO.destinatariInterni.length > 0) {
        corrispondenzaPartenzaVO.destinatariInterni.forEach(
          (destinatario) => {
            if (corrispondenzaPartenzaVO.destinatariString !== "") {
              corrispondenzaPartenzaVO.destinatariString =
                corrispondenzaPartenzaVO.destinatariString +
                ", ";
            }
              corrispondenzaPartenzaVO.destinatariString =
                corrispondenzaPartenzaVO.destinatariString +
                destinatario.idCmu + " - " + destinatario.nomeCmu;
          }
        );
      }
    } */
    if (e.stato) {
      corrispondenzaPartenzaVO.stato = e.stato.toString();
    }
    corrispondenzaPartenzaVO.operatore = this.mapperUtente.convertDtoToVo(
      e.operatore
    );
    if (e.mittente !== null) {
      corrispondenzaPartenzaVO.mittente = this.mapperSettore.convertDtoToVo(
        e.mittente
      );
    }
    //    corrispondenzaPartenzaDTO.primario  = this.mapperDocumenti.convertVoToDto(e.p)
     corrispondenzaPartenzaVO.riservata = e.riservata;
    /* const visibilitaUtenti = new Array<UtenteVO>();
    if (e.visibilitaPartenza) {
      e.visibilitaPartenza.forEach(element => {
        visibilitaUtenti.push(this.mapperUtente.convertDtoToVo(element.utente));
      });
      corrispondenzaPartenzaVO.visibilitaUtenti = this.mapperVisibilitaPartenza.convertListDtoToVo(
        e.visibilitaPartenza
      );
    } else {
      e.visibilitaPartenza = [];
    } */

    corrispondenzaPartenzaVO.tipoProtocollo = e.tipoProtocollo;
    if (e.tipoProtocollo) {
      switch (e.tipoProtocollo.toString()) {
        case "PARTENZA_DIGITALE":
          corrispondenzaPartenzaVO.tipoProtocolloAbbreviato = "PD";
          corrispondenzaPartenzaVO.tipoProtocolloLabel = "Partenza Digitale";
          break;
        case "PARTENZA_CARTACEO":
          corrispondenzaPartenzaVO.tipoProtocolloAbbreviato = "PC";
          corrispondenzaPartenzaVO.tipoProtocolloLabel = "Partenza Cartaceo";
          break;
        case "INTERNO_DIGITALE":
          corrispondenzaPartenzaVO.tipoProtocolloAbbreviato = "ID";
          corrispondenzaPartenzaVO.tipoProtocolloLabel = "Interno Digitale";
          break;
        case "INTERNO_CARTACEO":
          corrispondenzaPartenzaVO.tipoProtocolloAbbreviato = "IC";
          corrispondenzaPartenzaVO.tipoProtocolloLabel = "Interno Cartaceo";
          break;
      }
    }

    /* corrispondenzaPartenzaVO.stato = e.stato.toString();
    corrispondenzaPartenzaVO.dataInserimento = e.dataInserimento;
    if (e.datiFirma !== null && e.datiFirma !== undefined) {
      corrispondenzaPartenzaVO.datiFirmaPartenza = this.mapperDatiFirmaPartenza.convertDtoToVo(
        e.datiFirma
      );
    }
    if (e.statoPartenzaProtocollo !== null) {
      const statoPartenzaProto: StatoPartenzaProtocolloVO = new StatoPartenzaProtocolloVO();
      statoPartenzaProto.stato = e.statoPartenzaProtocollo.stato;
      statoPartenzaProto.dettaglio = e.statoPartenzaProtocollo.dettaglio;
      corrispondenzaPartenzaVO.statoPartenzaProtocollo = statoPartenzaProto;
    } */
    /* console.log(
      "[MapperCorrispondenzaPartenza.convertDtoToVo] return:",
      corrispondenzaPartenzaVO
    ); */
    return corrispondenzaPartenzaVO || new CorrispondenzaPartenzaVO();
  }
  convertListVoToDto(
    e: CorrispondenzaPartenzaVO[]
  ): CorrispondenzaPartenzaDTO[] {
    const corrispondenzaPartenzaDTOList = new Array<
      CorrispondenzaPartenzaDTO
    >();
    if (e != null) {
      e.forEach((corrPartenza) => {
        corrispondenzaPartenzaDTOList.push(this.convertVoToDto(corrPartenza));
      });
    }

    return (
      corrispondenzaPartenzaDTOList || new Array<CorrispondenzaPartenzaDTO>()
    );
  }

  convertListDtoToVo(
    t: CorrispondenzaPartenzaDTO[]
  ): CorrispondenzaPartenzaVO[] {
    const corrispondenzaPartenzaVOList = new Array<CorrispondenzaPartenzaVO>();
    if (t != null) {
      t.forEach((corrPartenza) => {
        corrispondenzaPartenzaVOList.push(this.convertDtoToVo(corrPartenza));
      });
    }

    return (
      corrispondenzaPartenzaVOList || new Array<CorrispondenzaPartenzaVO>()
    );
  }
}
